import Swiper from "swiper/bundle";
import "swiper/css/bundle";
/**
 * Layout: Tips
 * Slug: tips
 */

document.addEventListener('DOMContentLoaded', function() {
    const layouts = document.querySelectorAll('.flex-layout.tips-layout');

	layouts.forEach((layout) => {
		const prevEl = layout.querySelector(".swiper-nav-prev");
		const nextEl = layout.querySelector(".swiper-nav-next");
		const swiper = new Swiper(layout.querySelector(".swiper-container"), {
			spaceBetween: 16,
			navigation: {
				prevEl: prevEl,
				nextEl: nextEl,
			},
			breakpoints: {
				0: {
					slidesPerView: 1.125,
				},
				768: {
					slidesPerView: 2.5
				},
				993: {
					slidesPerView: 4
				}
			}
		});
	});
});
